<template>
    <v-card class="ma-0 mx-2 pa-2">  
        <v-row v-if="messages.length>0">
            <v-col class="ma-0 pa-0" cols="12">
                <v-card class="ma-1" :color="messages[0].color">
                    <v-card-title class="mb-0 pa-2">{{ messages[0].message }}</v-card-title>
                </v-card>
            </v-col>
        </v-row>
        <v-row v-if="item_messages.length>0">
            <v-col class="ma-0 pa-0" cols="12">
                <v-card class="ma-1" :color="item_messages[0].color">
                    <v-card-title class="mb-0 pa-2">{{ item_messages[0].message }}</v-card-title>
                </v-card>
            </v-col>
        </v-row>
        <v-row v-else>
            <v-col class="ma-0 pa-0" cols="12">
                <v-card class="ma-1" color="white">
                    <v-card-title class="mb-0 pa-2">&nbsp;</v-card-title>
                </v-card>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
    export default {
        props: {
            huis_encrid: {
                type: String,
                required: true
            },
        },
        data() {
            return {
                messages: [],
                item_messages: [],
            }
        },
        mounted() {
            this.getMessages();
        },
        methods: {
            getMessages() {
                this.$axios.post("ares/json/ares/huis/hsii/getMessages.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getMessages"
                    },
                    getMessages: {
                        huis_encrid: this.huis_encrid,
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        }); 
                    } else {
                        this.messages = res.data.getMessages;
                    }
                });
            },
            selectItem(id) {
                let newItemMessages = [];
                for (let iIndex=0;iIndex<this.messages.length;iIndex++) {
                    if (this.messages[iIndex].key === id) {
                        newItemMessages.push(this.messages[iIndex]);
                    }
                }
                this.item_messages = newItemMessages;
            }
        }  
    };
</script> 
